// Wir nutzen die Narrow function, damit der eigentliche Validierungsfehler am eigentlich Objekt liegt
// Dieser Typ ist für Dropdowns gedacht
import { type } from 'arktype';
import { today } from './common';

export const ObjectSelected = type({ 'id?': 'string' }).narrow((val, ctx) => {
  const id = val.id;
  if (id && id?.trim().length > 0) {
    return true;
  }
  return ctx.reject({});
});

export const NonEmptyString = type('string.trim |> string > 0');

export const FormArrayRowDataOf = type('<t>', {
  elements: { '[string]': 't' },
});

export const TodayOrLater = type('Date').narrow((d, ctx) => {
  const t = today();
  return d >= t || ctx.mustBe('today or later');
});

export const numberMatching = (re: RegExp) =>
  type('number').narrow(
    (n, ctx) => re.test(String(n)) || ctx.mustBe(`number matching ${re}`),
  );
